import { RouteContext } from '@common/contexts';
import { useContext } from 'react';
import { matchRoutes, RouteMatch, useLocation } from 'react-router-dom';

export const useCurrentRoute = (): RouteMatch | null => {
  const location = useLocation();
  const appRoutes = useContext(RouteContext.get());
  const matches = matchRoutes(appRoutes, location.pathname);
  return matches && matches.length > 0 ? matches[matches.length - 1] : null;
};
